var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAngelright(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 9.656,
    height: 16.15,
    viewBox: "0 0 9.656 16.15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#146f62;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M36.894,46.36l-7.081,7.187a.865.865,0,0,1-1.237,0l-.826-.838a.9.9,0,0,1,0-1.254l5.612-5.723-5.612-5.723a.9.9,0,0,1,0-1.254l.826-.838a.865.865,0,0,1,1.237,0L36.894,45.1A.9.9,0,0,1,36.894,46.36Z",
    transform: "translate(-27.494 -37.657)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAngelright);
export default __webpack_public_path__ + "static/media/angelright.22a8b574bd5557f3635569a2fce9610f.svg";
export { ForwardRef as ReactComponent };